// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectCard_wrapper__Y0ClE","imageWrapper":"ProjectCard_imageWrapper__aVK26","detailsWrapper":"ProjectCard_detailsWrapper__I93x1"};